import {Component, Output, EventEmitter, Input, OnInit} from '@angular/core';
import {Property, PropertyValue}                        from './properties.models';
import {Properties}                                     from './properties.service';
import {SchemaSettings}                                 from './schema.models';
import {Schema}                                         from '../../shared/api/bases/proxy/schemas/schema.interface';
import {Base}                                           from '../../shared/api/bases/api.models';
import {Platform}                                       from '../../shared/api/bases/proxy/messagecentral/api.models';
import {Api}                                            from '../../shared/api.service';

@Component({
    selector : 'filters',
    template: require('./filters.component.html'),
    styles: [require('./filters.component.scss')],
    providers : [Properties]
})

export class FiltersComponent implements OnInit {
    @Input()
    public base: Base;

    @Input()
    public schema: Schema;

    @Input()
    public settings: SchemaSettings;

    @Input()
    public filters: any[];

    @Output()
    public changed = new EventEmitter();

    protected platforms: Platform[] = [];

    public profileProperties: Property[]      = [];
    public profileGroupProperties: Property[] = [];

    public originalProfileGroupProperties: any = {};
    public selectedProfileGroupProperties: any = {};

    public selectedProfileProperties: any = {};

    constructor(private propertyService: Properties, private api: Api) {}

    ngOnInit() {
        this.api.bases().proxy(this.base.id).messagecentral().platforms().subscribe(
            (platforms: Platform[]) => {
                this.platforms = platforms;
                this.populateFilters();
            }
        );
    }

    private populateFilters() {
        this.profileProperties              = [];
        this.profileGroupProperties         = [];
        this.originalProfileGroupProperties = {};
        this.selectedProfileGroupProperties = {};
        this.selectedProfileProperties      = {};

        this.propertyService.getProfileProperties().subscribe((properties: Property[]) => {
            this.profileProperties = properties;
            this.profileProperties.forEach((property: Property) => this.selectedProfileProperties[property.field] = []);

            properties.forEach((property: Property) => {
                if (this.filters[property.field] && this.filters[property.field].length) {
                    property.values.forEach((propertyValue: PropertyValue) => {
                        if (this.filters[property.field].indexOf(propertyValue.id) !== -1) {
                            this.selectProfileProperty(property, propertyValue);
                        }
                    });
                }
            });
        });

        this.propertyService.getProfileGroupProperties(this.platforms).subscribe((properties: Property[]) => {
            this.profileGroupProperties = properties;
            this.profileGroupProperties.forEach((property: Property) => this.selectedProfileGroupProperties[property.field] = []);

            properties.forEach((property: Property) => {
                var values = [];
                property.values.forEach((value) => values.push(value));

                this.originalProfileGroupProperties[property.field] = {
                    field  : property.field,
                    values : values
                };

                if (this.filters[property.field] && this.filters[property.field].length) {
                    property.values.forEach((propertyValue: PropertyValue) => {
                        if (this.filters[property.field].indexOf(propertyValue.id) !== -1) {
                            this.selectProfileGroupProperty(property, null, propertyValue);
                        }
                    });
                }
            });
        });
    }

    selectProfileProperty(property: Property, propertyValue: PropertyValue) {
        let index = this.selectedProfileProperties[property.field].indexOf(propertyValue);

        if (index === -1) {
            this.selectedProfileProperties[property.field].push(propertyValue);
        } else {
            this.selectedProfileProperties[property.field].splice(index, 1);
        }

        // Selecting all the options means selecting nothing at all
        if (this.selectedProfileProperties[property.field].length === property.values.length) {
            this.selectedProfileProperties[property.field] = [];
        }

        this.emitFilters();
    }

    selectProfileGroupProperty(property: Property, event?: Event, propertyValue?: PropertyValue): boolean {
        var propertyValueIndex = 0;

        if (event) {
            property.values.forEach((value: PropertyValue, index) => {
                if (value.id === event.srcElement['value']) {
                    propertyValueIndex = index;
                    return;
                }
            });
        } else if (propertyValue) {
            propertyValueIndex = property.values.indexOf(propertyValue);
        }

        this.selectedProfileGroupProperties[property.field].push(property.values[propertyValueIndex]);

        // Clear every item when everything is selected
        if (this.selectedProfileGroupProperties[property.field].length ===
            this.originalProfileGroupProperties[property.field].values.length
        ) {
            this.selectedProfileGroupProperties[property.field] = [];
        }

        property.values = [];

        this.originalProfileGroupProperties[property.field].values.forEach((propertyValue: PropertyValue) => {
            if (this.selectedProfileGroupProperties[property.field].indexOf(propertyValue) === -1) {
                property.values.push(propertyValue);
            }
        });

        this.emitFilters();

        return false;
    }

    deselectProfileGroupProperty(property: Property, propertyValue: PropertyValue) {
        this.selectedProfileGroupProperties[property.field].splice(
            this.selectedProfileGroupProperties[property.field].indexOf(propertyValue),
            1
        );

        property.values = [];
        this.originalProfileGroupProperties[property.field].values.forEach((propertyValue: PropertyValue) => {
            if (this.selectedProfileGroupProperties[property.field].indexOf(propertyValue) === -1) {
                property.values.push(propertyValue);
            }
        });

        this.emitFilters();

        return false;
    }

    private emitFilters(): void {
        var filters = {};

        for (let field in this.selectedProfileProperties) {
            filters[field] = [];

            this.selectedProfileProperties[field].forEach((value: PropertyValue) => {
               filters[field].push(value.id);
            });
        }

        for (let field in this.selectedProfileGroupProperties) {
            filters[field] = [];

            this.selectedProfileGroupProperties[field].forEach((value: PropertyValue) => {
               filters[field].push(value.id);
            });
        }

        this.changed.emit(filters);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/schemas/components/filters.component.ts